module.exports = __webpack_public_path__ + "img/10.dirty_shower.3b857461.svg";